define('presentation/signup/validators/signupPaymentMethodValidator',[
        'businessServices/country/countryCode',
        'businessServices/country/countryRegions',
        'businessServices/creditCards/creditCardValidations',
        'constants/countryEnumerations',
        'presentation/common/validation/commonValidator',
        'presentation/common/validation/validationRule',
    ],
    function() {
        return function() {
            const self = this;

            const CommonValidatorConstructor = require('presentation/common/validation/commonValidator');
            const ValidationRulesConstructor = require('presentation/common/validation/validationRule');

            const CreditCardValidationConstructor = require('businessServices/creditCards/creditCardValidations');
            const _creditCardValidations = new CreditCardValidationConstructor();

            const CountryCodeConstructor = require('businessServices/country/countryCode');
            const _countries = new CountryCodeConstructor();

            const CountryRegionsConstructor = require('businessServices/country/countryRegions');
            const _countryRegions = new CountryRegionsConstructor();

            const _countryEnumerations = require('constants/countryEnumerations');

            let _commonValidator = null;
            let _viewModel;

            self.registerViewModel = function(viewModel) {
                _viewModel = viewModel;
                _commonValidator = new CommonValidatorConstructor(_viewModel);

                const validationRules = new ValidationRulesConstructor();
                validationRules.field("cardHolderName")
                    .addValidationKeyUp(_validateCardHolderNameRequired)
                    .addValidationI18n(_validateCardHolderNameRequired, 'signupPaymentMethod:cardHolderNameRequired')
                    .addValidationI18n(_validateCardHolderName, 'signupPaymentMethod:noSpecialCharacters');
                validationRules.field("cardNumber")
                    .addValidationKeyUp(_validateCardNumber)
                    .addValidationI18n(_validateCardNumberRequired, 'signupPaymentMethod:cardNumberRequired')
                    .addValidationI18n(_validateCardNumber, 'signupPaymentMethod:cardNumberInvalid');
                validationRules.field('cvvCode')
                    .addValidationKeyUp(_validateMaybeCvvCode)
                    .addValidationI18n(_validateCvvCodeRequired, 'signupPaymentMethod:cvvRequired')
                    .addValidationI18n(_validateCvvCode, 'signupPaymentMethod:cvvInvalid');
                validationRules.fieldGroup("expirationDate", ["expirationMonth", "expirationYear"])
                    .addValidationI18n(_validateExpirationDate, 'signupPaymentMethod:expirationDateInvalid');
                validationRules.field("addressLineOne")
                    .addValidationKeyUp(_commonValidator.isStringWithValue)
                    .addValidationI18n(_commonValidator.isStringWithValue, 'signupPaymentMethod:addressRequired');
                validationRules.field("city")
                    .addValidationKeyUp(_commonValidator.isStringWithValue)
                    .addValidationI18n(_commonValidator.isStringWithValue, 'signupPaymentMethod:cityRequired');
                validationRules.field("stateOrProvince")
                    .addValidationKeyUp(_validateStateOrProvince)
                    .addValidationI18n(_validateStateOrProvince, _stateOrProvinceRequiredI18nKey);
                validationRules.field("postalCode")
                    .addValidationKeyUp(_validatePostalCodeValid)
                    .addValidationI18n(_commonValidator.isStringWithValue, _postalCodeRequiredI18nKey)
                    .addValidationI18n(_validatePostalCodeValid, _postalCodeInvalidI18nKey);

                validationRules.validationGroupKeyUp('isAddressValid', ["addressLineOne", "city", "postalCode"]);
                validationRules.validationGroupKeyUp('isCardFieldsValid', ["cardHolderName", "cardNumber", "expirationDate", "cvvCode"]);

                _commonValidator.setValidationRules(validationRules);
            };

            self.validate = () =>_commonValidator.validate();

            const _noSpecialCharacters = (name) => /^[a-zA-Z0-9 ']*$/.test(name);

            const _removeSpacesFromString = (string) => string.replace(/\s+/g, '');

            const _isCvvRequired = (cvv) => {
                if (_viewModel.isBypassPreAuthorizationSelected() === true) {
                    return true;
                }
                return _commonValidator.isStringWithValue(cvv);
            };

            const _isCvvValid = (cvv) => {
                if (_commonValidator.isStringWithValue(cvv) === false && _viewModel.isBypassPreAuthorizationSelected() === true) {
                    return true;
                }
                return _creditCardValidations.validateCvv(cvv, _viewModel.cardNumber());
            };

            const _isCvvMaybeValid = (cvv) => {
                if (_commonValidator.isStringWithValue(cvv) === false && _viewModel.isBypassPreAuthorizationSelected() === true) {
                    return true;
                }
                return /^\d{3,4}$/.test(cvv);
            };

            const _validateCardHolderNameRequired = (cardHolderName) => {
                if (_viewModel.isCardEntryVisible() === false) {
                    return true;
                }

                return _commonValidator.isStringWithValue(cardHolderName);
            };

            const _validateCardHolderName = (cardHolderName) => {
                if (_viewModel.isCardEntryVisible() === false) {
                    return true;
                }

                return _noSpecialCharacters(cardHolderName);
            };

            const _validateCardNumberRequired = (cardNumber) => {
                if (_viewModel.isCardEntryVisible() === false) {
                    return true;
                }

                return _commonValidator.isStringWithValue(cardNumber);
            };

            const _validateCardNumber = (cardNumber) => {
                if (_viewModel.isCardEntryVisible() === false) {
                    return true;
                }

                return _creditCardValidations.validateCardNumber(cardNumber);
            };

            const _validateCvvCodeRequired = (cvvCode) => {
                if (_viewModel.isCardEntryVisible() === false) {
                    return true;
                }

                return _isCvvRequired(cvvCode);
            };

            const _validateCvvCode = (cvvCode) => {
                if (_viewModel.isCardEntryVisible() === false) {
                    return true;
                }

                return _isCvvValid(cvvCode);
            };

            const _validateMaybeCvvCode = (cvvCode) => {
                if (_viewModel.isCardEntryVisible() === false) {
                    return true;
                }

                return _isCvvMaybeValid(cvvCode);
            };

            const _validateExpirationDate = (expirationMonth, expirationYear) => {
                if (_viewModel.isCardEntryVisible() === false) {
                    return true;
                }

                if (expirationMonth[0] && expirationYear[0]){
                    return _creditCardValidations.validateExpirationDate(expirationMonth[0], expirationYear[0]);
                }

                return false;
            };

            const _validateStateOrProvince = (stateOrProvince) => {
                if (stateOrProvince[0]) {
                    return _countryRegions.isValidStateOrProvince(stateOrProvince[0], _viewModel.country()[0]);
                }
                return false;
            };

            const _stateOrProvinceRequiredI18nKey = ko.pureComputed(() => {
                return _viewModel.country()[0] === _countryEnumerations.ca ?
                    'signupPaymentMethod:provinceRequired' :
                    'signupPaymentMethod:stateRequired';
            });


            const _validatePostalCodeValid = (postalCode) => {
                return _creditCardValidations.validatePostalCodeFormat(_removeSpacesFromString(postalCode), _currentCountry());
            };

            const _currentCountry = ko.pureComputed(() => {
                if (_viewModel.country()[0]) {
                    return _countries.findByAbbreviation(_viewModel.country()[0]);
                }

                return _countries.getDefaultCountry();
            });

            const _postalCodeRequiredI18nKey = ko.pureComputed(() => _currentCountry().hasProvinces ? 'postalCodeRequired' : 'zipCodeRequired');

            const _postalCodeInvalidI18nKey = ko.pureComputed(() => _currentCountry().hasProvinces ? 'postalCodeInvalid' : 'zipCodeInvalid');
        };
    });

